import { AfterViewInit, ChangeDetectorRef, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilderComponent } from '@microsec/components';
import { FormItem } from '@microsec/models';
import { IDS_FORM_PARAMS } from '../shared-active-scan-form.component';
import { FormArray, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { VALIDATOR_TYPE } from '@microsec/constants';
import { CommonModule } from '@angular/common';
import { InputNumberModule } from 'primeng/inputnumber';

export const PORT_OPTION_VALUES = {
  ALL_PORTS: 'all_ports',
  SPECIFIC_PORTS: 'specific_ports',
};

const PORT_OPTIONS = [
  { label: 'All Ports', value: PORT_OPTION_VALUES.ALL_PORTS },
  { label: 'Specific Ports or Port Ranges', value: PORT_OPTION_VALUES.SPECIFIC_PORTS },
];

export const PORT_RANGE_PATTERN =
  '^([1-9][0-9]{0,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])(:([1-9][0-9]{0,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5]))?$';

@Component({
  selector: 'app-sas-port-config',
  templateUrl: './sas-port-config.component.html',
  styleUrls: ['./sas-port-config.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputNumberModule, FormBuilderComponent],
})
export class SasPortConfigComponent implements AfterViewInit {
  @Input() customServices: any[] = [];

  @ViewChild('fb') form!: FormBuilderComponent;

  @ViewChild('customPortFields') cp!: TemplateRef<any>;

  @ViewChild('customPortLabel') cpl!: TemplateRef<any>;

  fields: FormItem[] = [];

  showConfig = false;

  portOptions = PORT_OPTIONS;

  portOptionValues = PORT_OPTION_VALUES;

  IDS_FORM_PARAMS = IDS_FORM_PARAMS;

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    const portToScanField: FormItem = Object.assign(new FormItem(), {
      name: IDS_FORM_PARAMS.PORTS_TO_SCAN,
      hasNoLabel: true,
      rowStyleClass: 'ml-3',
      field: 'input-chip',
      regex: PORT_RANGE_PATTERN,
      fieldInfo: 'Enter port number individually or range of ports separated by : (colon) e.g. 22:55 for port 22 to 55',
      placeholder: 'Input Ports or Port Ranges (e.g. 22:55). Use comma (,) as delimiter.',
      extraValidation: (currentValue: string) => {
        const colonIndex = currentValue.indexOf(':');
        if (colonIndex > -1) {
          const [lower, upper] = currentValue.split(':');
          if (Number(lower) >= Number(upper)) {
            return { incorrect: true, message: 'Invalid port range' };
          }
        }
        return null;
      },
      defaultValue: [],
      hidden: true,
    } as FormItem);
    const fields: FormItem[] = [
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.PORT_OPTIONS,
        label: 'Ports to Scan',
        labelStyleClass: 'font-bold mt-3',
        rowStyleClass: 'pb-0 mb-0',
        field: 'radio',
        options: [...PORT_OPTIONS],
        defaultValue: PORT_OPTION_VALUES.ALL_PORTS,
        layout: 'vertical',
        required: true,
      } as FormItem),
      portToScanField,
      Object.assign(new FormItem(), {
        hasNoLabel: true,
        field: 'custom',
        customField: this.cpl,
        hidden: false,
      } as FormItem),
      Object.assign(new FormItem(), {
        name: IDS_FORM_PARAMS.CUSTOM_PORTS,
        hasNoLabel: true,
        field: 'custom',
        customField: this.cp,
        defaultValue: [],
        hidden: !this.showConfig,
      } as FormItem),
    ];

    fields.forEach((field) => {
      field.isFullSize = true;
    });
    this.fields = fields;

    setTimeout(() => {
      if (!!this.form?.form?.get(IDS_FORM_PARAMS.CUSTOM_PORTS)) {
        this.form?.form?.setControl(IDS_FORM_PARAMS.CUSTOM_PORTS, this.fb.array([]));
        this.addCustomPortPairs();
      }
      this.form.setChangeEvent(IDS_FORM_PARAMS.PORT_OPTIONS, (value) => [
        this.form?.setControlValidatorsAndVisibility(
          IDS_FORM_PARAMS.PORTS_TO_SCAN,
          value === PORT_OPTION_VALUES.SPECIFIC_PORTS ? [VALIDATOR_TYPE.REQUIRED] : [],
        ),
      ]);
      this.cdr.detectChanges();
    });
  }

  addCustomPortPairs() {
    ((this.customServices as any[]) || []).forEach((s: any) => {
      const customPortGroup = this.fb.group({
        [IDS_FORM_PARAMS.SERVICE]: [s[IDS_FORM_PARAMS.SERVICE], Validators.required],
        [IDS_FORM_PARAMS.PORT]: [s[IDS_FORM_PARAMS.PORT], [Validators.required, Validators.min(1)]],
      });
      this.customPortPairArray?.push(customPortGroup);
    });
  }

  handleCustomPortLabelToggle() {
    this.showConfig = !this.showConfig;
    this.form.setControlVisibility(IDS_FORM_PARAMS.CUSTOM_PORTS, this.showConfig);
  }

  get customPortPairArray() {
    return this.form?.form?.get(IDS_FORM_PARAMS.CUSTOM_PORTS) as FormArray;
  }
}
